import { type ReactNode } from "react";
import { Navigate } from "react-router";

import { Spinner } from "@/components/spinner.tsx";
import { useAuth } from "@/hooks/use-auth.ts";
import type { Role } from "@/models/user.ts";

interface AuthGuardProps {
    children: ReactNode;
    roles: Role[];
}

export function AuthGuard({ children, roles }: AuthGuardProps) {
    const { authed, initialized, role: userRole } = useAuth();

    if (!initialized) return <Spinner />;

    if (authed && roles.includes(userRole)) {
        return <>{children}</>;
    }

    return <Navigate to="/login" replace />;
}
